//
//
//
//
//
export default {
  data: function data() {
    return {
      body: "",
      is_Ie: false
    };
  },
  mounted: function mounted() {
    this.getRss();
  },
  methods: {
    getRss: function getRss() {
      var _this = this;

      this.$store.dispatch('_GetRss').then(function (res) {
        _this.body = res.data.Data;
      });
    }
  }
};